import { Col, DatePicker, Form, Input, Modal, Row, Select } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { CreateClientDto } from "../../entities/dto/client.dto";
import { Client } from "../../entities/interfaces/client";
import ClientService from "../../services/clients.service";
import { useEffect } from "react";

type Props = {
  open: boolean;
  selected?: Client;
  onChange: (client?: Client) => void;
  onClose: () => void;
  defaultValue?: Partial<CreateClientDto>;
};

const ManageClient = ({
  open,
  onChange,
  selected,
  onClose,
  defaultValue,
}: Props) => {
  const [form] = Form.useForm<any>();
  const isCreate = !selected;
  const title = isCreate ? "Create Client" : "Update Client";
  const okButtonText = isCreate ? "Create" : "Update";

  useEffect(() => {
    if (!isCreate) {
      form.setFieldsValue({
        ...selected,
        dob: selected.dob ? dayjs(selected.dob) : undefined,
      });
    }

    if (defaultValue) {
      form.setFieldsValue(defaultValue);
    }
  }, [defaultValue, selected]);

  const handleSubmit = async (values: CreateClientDto) => {
    const res = isCreate
      ? await ClientService.create(values)
      : await ClientService.update(selected.id, values);

    if (res?.success) {
      isCreate
        ? toast.success("Client created")
        : toast.success("Client updated");
      onChange(res.data);
      closeModal();
    }
  };

  const closeModal = () => {
    form.resetFields();
    onClose();
  };

  const onlyNumbersValidator = (_: any, value: string) => {
    if (!value || /^[0-9]+$/.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Only numbers are allowed"));
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={form.submit}
      onCancel={closeModal}
      centered
      okText={okButtonText}
      width={700}
    >
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please input name!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="Phone Number"
              name="phone"
              rules={[
                { required: true, message: "Please input phone number!" },
                {
                  min: 10,
                  max: 10,
                  message: "Phone number should be 10 digits",
                },
                { validator: onlyNumbersValidator },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col span={12}>
            <Form.Item label="Date of birth" name="dob">
              <DatePicker className="w-full" format={"DD/MM/YYYY"} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Gender"
              name="gender"
              rules={[{ required: true, message: "Please input gender!" }]}
            >
              <Select>
                <Select.Option value="MALE">Male</Select.Option>
                <Select.Option value="FEMALE">Female</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ManageClient;
